import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { ITopology } from "../../app/apiSlice";
import { useSecureApplication } from "../../hooks/KeycloackConnection";

const OpenTopology = ({topology}:{topology: ITopology}) => {

    const { hasAnyPerm} = useSecureApplication()
    const navigate = useNavigate();

  return (
    <>
      <Button
        title={'Ouvrir'}
        disabled={!hasAnyPerm("pipelines.all", "pipelines_upd")}
        onClick={() => {
            navigate(`/treatments/editor?t=${topology.id}&v=${topology.version}`)
        }}
        icon="pi pi-pencil"
        className="p-button-text"
        key={topology.id}
      />
    </>
  );
};

export default OpenTopology;
